import { render } from "./AlarmSetting.vue?vue&type=template&id=6622fc8e"
import script from "./AlarmSetting.vue?vue&type=script&lang=js"
export * from "./AlarmSetting.vue?vue&type=script&lang=js"

import "./AlarmSetting.vue?vue&type=style&index=0&id=6622fc8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__